import { loadingService } from './loading.service';
import { alertService } from './alert.service';

const getRequestOptions = (methodType, options) => {
    let headers = {
        'Content-Type': 'application/json'
    };

    let token = sessionStorage.getItem('sessionToken');
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    if (methodType === 'FORMDATA') {
        delete headers['Content-Type'];

        return {
            method: 'POST',
            headers: headers,
            credentials: "include",
            body: options.body ? options.body : null
        };
    }

    return {
        method: methodType,
        headers: headers,
        credentials: "include",
        body: options.body ? JSON.stringify(options.body) : null
    };
}

const arrayBufferToBase64 = (arrayBuffer) => {
    if (!arrayBuffer) return "";

    let binary = '';
    let bytes = new Uint8Array(arrayBuffer);

    for (var i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
}

const handleResponse = (response) => {
    if (response.headers.get('Content-Type') == 'application/octet-stream') {
        return response.arrayBuffer().then(arrayBuffer => {
            if (!response.ok) {
                if ([401, 403].indexOf(response.status) !== -1) {
                    //redirect in login 
                    window.location.hash = '/';
                    return;
                }
                return Promise.reject({
                    Message: response.statusText
                });
            }

            return arrayBufferToBase64(arrayBuffer)
        });
    }

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                //redirect in login 
                window.location.hash = '/';
                return;
            }

            if (data && data.Message) {
                return Promise.reject(data);
            }

            return Promise.reject({
                Message: response.statusText
            });
        }

        return data;
    });
}

const request = (methodType, options) => {
    const url = window?.apiConfig?.url ?? sessionStorage.getItem('configURL');
    if (!url) {
        console.error("config file is not defined.");
        return;
    }

    loadingService.set(true);

    // add query strings
    if (options.queryString) {
        var queryParams = Object.getOwnPropertyNames(options.queryString);
        options.methodName += '?';

        queryParams.forEach(param => options.methodName += param + '=' + (options.queryString[param] != undefined ? encodeURIComponent(options.queryString[param]) : '') + '&');
        if (options.methodName.slice(-1) === '&') {
            options.methodName = options.methodName.slice(0, -1);
        }
    }

    // add headers & body
    const requestOptions = getRequestOptions(methodType, options);

    if (methodType == "GET" && options.openBlankPage) {
        loadingService.set(false);

        let token = sessionStorage.getItem('sessionToken');
        if (token) {
            // adaugam subscriptionId pt APM
            options.methodName += options.queryString ? '&' : '?';
            options.methodName += "authorization-key=" + token;
        }

        return window.open(`${url}${options.methodName}`, '_blank');
    }

    return fetch(`${url}${options.methodName}`, requestOptions)
        .then(handleResponse)
        .then(
            response => {
                // stop loading + return response
                loadingService.set(false);
                return response;
            },
            error => {
                // stop loading + alerta
                loadingService.set(false);
                alertService.error(error?.Message);
            });
}

// call with methodName, queryString, body
export const requestService = {
    get: (options) => request('GET', options),
    post: (options) => request('POST', options),
    put: (options) => request('PUT', options),
    formData: (options) => request('FORMDATA', options)
};
